import React from 'react';

export default function Section({ label }) {
    return(
        <div className='inline-flex items-center gap-2 px-4 py-2 bg-black/40 backdrop-blur-sm rounded-full shadow-md border border-fuchsia-500/30'>
            <span className='w-3 h-3 rounded-full bg-fuchsia-400 animate-pulse'></span>
            <span className='text-sm font-semibold text-gray-300'>{label}</span>
        </div>
    )
} 